import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { SlideToggle } from '../../../../components/slide-toggle';
import * as Animations from '../../../../constants/animation';
import { Icon } from '@purpurds/purpur/icon';
import { icons } from 'theme/icons';
import NOB from '../../../../constants/language-strings';
import { purpurColorFunctionalWhite, purpurColorPurple100, purpurColorPurple800, } from '@purpurds/tokens/color/variables';
import styled from 'styled-components';
import { purpurShadowMd } from '@purpurds/tokens/shadow/variables';
const TechnicalDetailsContainer = styled.div `
  display: flex;
  flex-direction: column;
  background-color: ${purpurColorFunctionalWhite};
  box-shadow: ${purpurShadowMd};
  color: ${purpurColorPurple800};
  border-radius: 4px;
`;
const TechnicalDetailsDropdown = styled.button `
  font-size: 20px;
  font-weight: 400;
  background-color: ${purpurColorFunctionalWhite};
  min-width: 320px;;
  width: 100%;
  height: 50px;
  padding: 0 18px 0 16px;
  border: none;
  z-index: 1;
  cursor: pointer;
  border-radius: 4px;
`;
const TechnicalDetailsContent = styled.div `
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
`;
const DetailsContainer = styled.div `
  background-color: ${purpurColorPurple100};
  overflow: hidden;
  font-size: 18px;
  border-radius: 0 0 4px 4px;
`;
const TechnicalDetailItems = styled.div `
  padding: 0 16px;

  &:first-child {
    padding-top: 16px;
  }

  &:last-child {
    padding-bottom: 16px;
  }
`;
const TechnicalDetailItem = styled.div `
  display: flex;

  div {
    overflow: hidden;
    text-overflow: ellipsis;
    padding-right: 10px;
    width: 280px;
  }
`;
const StyledKey = styled.div `
  line-height: 1.2;
  font-weight: 400;
`;
const StyledValue = styled.div `
  font-weight: 300;
`;
const StyledIcon = styled(Icon) `
  color: ${purpurColorPurple800};
`;
export const TechnicalDetails = ({ technicalDetails, capacity }) => {
    const technicalDetailsList = Object.keys(technicalDetails);
    const Details = () => {
        const Azimuth5G = () => {
            var _a, _b, _c, _d;
            return (_jsxs(TechnicalDetailItems, { children: [_jsxs(TechnicalDetailItem, { children: [_jsx(StyledKey, { children: "Anbefalt retning i grader (5G)" }), _jsx(StyledValue, { children: (_b = (_a = capacity[1]) === null || _a === void 0 ? void 0 : _a.direction) !== null && _b !== void 0 ? _b : '-' })] }), _jsxs(TechnicalDetailItem, { children: [_jsx(StyledKey, { children: "Kapasitet / dekning" }), _jsx(StyledValue, { children: !capacity[1]
                                    ? 'Ingen dekning'
                                    : ((_c = capacity[1]) === null || _c === void 0 ? void 0 : _c.capacityLeft) === 0
                                        ? 'Ingen kapasitet'
                                        : (_d = capacity[1]) === null || _d === void 0 ? void 0 : _d.capacityLeft })] })] }, "5G"));
        };
        const Azimuth4G = () => {
            var _a, _b, _c, _d;
            return (_jsxs(TechnicalDetailItems, { children: [_jsxs(TechnicalDetailItem, { children: [_jsx(StyledKey, { children: "Alternativ retning i grader (4G)" }), _jsx(StyledValue, { children: (_b = (_a = capacity[0]) === null || _a === void 0 ? void 0 : _a.direction) !== null && _b !== void 0 ? _b : '-' })] }), _jsxs(TechnicalDetailItem, { children: [_jsx(StyledKey, { children: "Kapasitet / dekning" }), _jsx(StyledValue, { children: !capacity[0]
                                    ? 'Ingen dekning'
                                    : ((_c = capacity[0]) === null || _c === void 0 ? void 0 : _c.capacityLeft) === 0
                                        ? 'Ingen kapasitet'
                                        : (_d = capacity[0]) === null || _d === void 0 ? void 0 : _d.capacityLeft })] })] }, "4G"));
        };
        const AllTechnicalDetails = () => {
            return technicalDetailsList
                .filter(key => key != 'Azimuth_proposed')
                .map((key, index) => {
                return (_jsx(TechnicalDetailItems, { children: technicalDetails[key] && (_jsxs(TechnicalDetailItem, { children: [_jsx(StyledKey, { children: key }), _jsx(StyledValue, { children: technicalDetails[key] })] })) }, `${key}${index}`));
            });
        };
        return (_jsxs(_Fragment, { children: [_jsx(AllTechnicalDetails, {}), capacity && (_jsxs(_Fragment, { children: [_jsx(Azimuth5G, {}), _jsx(Azimuth4G, {})] }))] }));
    };
    return (_jsx("div", { children: technicalDetailsList.length > 0 && (_jsx(SlideToggle, { duration: Animations.DURATION, collapsed: true, children: ({ onToggle, setCollapsibleElement, toggleState }) => (_jsxs(TechnicalDetailsContainer, { children: [_jsx(TechnicalDetailsDropdown, { onClick: onToggle, children: _jsxs(TechnicalDetailsContent, { children: [_jsx("span", { children: NOB.WORKORDER_TABS.TECHNICAL_INFORMATION_HEADING }), _jsx("span", { style: {
                                        display: 'flex',
                                        transform: toggleState === 'EXPANDING' || toggleState === 'EXPANDED'
                                            ? 'rotate(180deg)'
                                            : 'rotate(0deg)',
                                        transition: 'transform 0.3s ease',
                                    }, children: _jsx(StyledIcon, { svg: icons.chevronDown, size: 'md' }) })] }) }), _jsx(DetailsContainer, { ref: setCollapsibleElement, children: _jsx(Details, {}) })] })) })) }));
};
